document.addEventListener("DOMContentLoaded", function () {
  var images = window.images360 || [];

  if (!images.length) return;

  var container = document.getElementById("spritespin-container");

  if (container && window.SpriteSpin) {
    window.SpriteSpin.create({
      source: images,
      width: 600,
      height: 400,
      frames: images.length,
      sense: -1,
      container: container
    });
  }
});
